import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";

const AreaItem = ({ area = 0, index }) => (
    <Row className="mt-2">
        <Col xl={4} xs={6}>
            Area {index + 1}
        </Col>
        <Col xl={8} xs={6} className="text-end">
            {area} Acres
        </Col>
    </Row>
);

AreaItem.propTypes = {
    area: PropTypes.number,
    index: PropTypes.number.isRequired,
};

export default AreaItem;
